import headerTpl from '../templates/ad_builder/header.html';

export default function builderHeader() {
  return {
    restrict: 'E',
    template: headerTpl,
    controller: 'BuilderHeaderController',
    controllerAs: 'headerVm'
  };
}
